import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { withIntl, IntlProps } from 'ha/i18n';

import * as SearchFilters from 'ha/types/SearchFilters';
import { CanonicalBills } from 'ha/constants/Filters';

import FilterSwitchGroup from './FilterSwitchGroup';

interface Props {
  bills: SearchFilters.BillsFilterValue;
  className?: string;
  onChange: (value: SearchFilters.BillsFilterValue) => void;
}

interface BillOption {
  value: SearchFilters.BillsValue;
  label: string;
  'data-test-locator'?: string;
}

export const BillsFilter: React.SFC<Props & IntlProps> = ({
  bills,
  onChange,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Bills')}</Typography>

    <FilterSwitchGroup
      value={bills as string}
      onChange={(val: SearchFilters.BillsFilterValue) => onChange(val)}
      options={
        [
          {
            value: CanonicalBills.Included,
            label: T('Bills Included'),
            'data-test-locator': 'Filter Bills Included',
          },
          {
            value: CanonicalBills.Excluded,
            label: T('Bills Excluded'),
            'data-test-locator': 'Filter Bills Excluded',
          },
        ] as BillOption[]
      }
    />
  </React.Fragment>
);

export default withIntl(BillsFilter);
